export class TwDocumentacionCamViewModel {
    public Id: number | null;
    public IdCampania: number | null;
    public IdTipoDocumentacion: number | null;
    public IdTipoDocumentacionDescripcion = '';
    public Obligatoria: boolean;
    public MarkToDelete: number;
}
